import { render, staticRenderFns } from "./SurveySendModal.vue?vue&type=template&id=4223eeb6&scoped=true"
import script from "./SurveySendModal.vue?vue&type=script&lang=js"
export * from "./SurveySendModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4223eeb6",
  null
  
)

export default component.exports